__turbopack_context__.v({
  "card": "vXgQdG_card",
  "cardContainer": "vXgQdG_cardContainer",
  "description": "vXgQdG_description",
  "heading": "vXgQdG_heading",
  "imgContainer": "vXgQdG_imgContainer",
  "para": "vXgQdG_para",
  "root": "vXgQdG_root",
  "tag": "vXgQdG_tag",
  "text": "vXgQdG_text",
  "title": "vXgQdG_title",
});
